<div class="bubble-wrapper edit-filter-wrap">
    <div *ngFor="let filter of selectedFilters" class="uitk-c-button fil_btn uitk-c-button--ghost uitk-u-margin-right--base uitk-u-margin-bottom--xs">
        {{getBubbleTitle(filter)}}
   </div>
   <div *ngIf="showEditFilter" class="edit-filter-wrap" >
        <p (click)="onEditFilter()" (keydown.enter)="onEditFilter()" 
        (keydown.space)="onEditFilter()" 
        tabindex="0" 
        role="button" class="uitk-c-button uitk-c-button--default uitk-u-margin-right--base uitk-u-margin-bottom--xs edit-filter">Edit Filters</p>
   </div>
</div>

